import { useQuery } from '@tanstack/react-query';

import { fetchMerchantOptions } from 'common/api/merchants';

export const useWarpMerchantsForUser = (enabled?: boolean) => {
  return useQuery({
    queryKey: ['userMerchantOptions'],
    queryFn: fetchMerchantOptions,
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    enabled,
    retry: 3,
    retryDelay: (count) => count * 5 * 1000,
  });
};
